import { StackScreenProps } from '@react-navigation/stack'
import * as Clipboard from 'expo-clipboard'
import { IconButton } from 'react-native-paper'
import Toast from 'react-native-root-toast'
import { ScreenWrapper, MButton } from '../../../@ui'
import { useGlobalStyles } from '../../../contexts/global-styles.provider'
import { Env } from '../../../env'
import {
  Contribution,
  useContributionByIdQuery,
} from '../../../generated/graphql'
import { useTheme } from '../../../hooks/theme.hook'
import { useWechatShareInit } from '../../../hooks/wechat-share.hook'
import { AppNavigatorParams } from '../../../navigation/types'
import { MelddTaskTargetType } from '../../tasks/task.types'
import { ContributionCard } from './components/contribution.card'
import { View } from 'react-native'
import { useIsMobileDevice } from '../../../hooks/is-mobile.hook'

export function PerspectiveContributionScreen({
  route,
}: StackScreenProps<AppNavigatorParams, 'PerspectiveContribution'>) {
  const { contributionId } = route.params
  const theme = useTheme()
  const isMobile = useIsMobileDevice()
  const globalStyles = useGlobalStyles()

  const { data: contributionData } = useContributionByIdQuery({
    variables: { contributionId },
  })
  const contribution = contributionData?.contributionById as Contribution

  const saveContributionUrl = async () => {
    let urlToClipBoard = `${Env.WEB_APP_URL}/PerspectiveContribution?contributionId=${contributionId}`
    Toast.show('URL copied!', { position: Toast.positions.TOP })
    await Clipboard.setStringAsync(urlToClipBoard)
  }

  useWechatShareInit(() => {
    if (!contribution) return null
    return {
      title: contribution.contributionType,
      description: `${contribution.input} and ${contribution.bumpCount} bump(s)`,
    }
  }, [contribution])

  if (!contribution) {
    return null
  }

  return (
    <View style={globalStyles.pageContainer}>
      <ScreenWrapper>
        <View
          style={{
            paddingTop: theme.spacing(4),
            marginHorizontal: theme.spacing(isMobile ? 1 : 5),
          }}
        >
          <ContributionCard
            contribution={contribution}
            children={
              <IconButton
                style={{ marginTop: 24 }}
                mode="contained-tonal"
                size={20}
                icon="content-copy"
                onPress={() => saveContributionUrl()}
              />
            }
          />
        </View>
        {/* // Allow some scroll to avoid MButton to overlapp key actions */}
        <View style={{ height: 40 }}></View>
      </ScreenWrapper>

      <MButton
        targetType={MelddTaskTargetType.ARTICLE_TASK}
        targetId={contribution.articleId}
        preview={''}
      />
    </View>
  )
}
export default PerspectiveContributionScreen
